import { useEffect, useState } from 'react';

const useCountdownSeconds = () => {
    const [secondsLeft, setSecondsLeft] = useState(0);
    const [isCounting, setIsCounting] = useState(false);
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        if (secondsLeft <= 0) {
            setIsComplete(true);
            return;
        }

        let intervalId;
        if (isCounting) {
            intervalId = setInterval(() => {
                setSecondsLeft((prev) => {
                    if (prev === 1) {
                        setIsComplete(true);
                        setIsCounting(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        // eslint-disable-next-line consistent-return
        return () => clearInterval(intervalId);
    }, [secondsLeft, isCounting]);

    const startCountdown = (value) => {
        setSecondsLeft(value);
        setIsComplete(false);
        setIsCounting(true);
    };

    return {
        secondsLeft,
        startCountdown,
        isCounting,
        isComplete,
    };
};

export default useCountdownSeconds;
